import React from 'react';
import Card from '@/component/card';
import style from './style';

const FakeCardDevice = () => {
  return (
    <>
      <div className="fake-card-device">
        <Card cardPropLayout="device">
          <div className="skeleton fake-card-device--image" />
          <div className="skeleton fake-card-device--full" />
          <div className="skeleton fake-card-device--medium" />
        </Card>
      </div>
      <style jsx>{style}</style>
    </>
  );
};

export default FakeCardDevice;
